var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyRanking = function SvgEmptyRanking(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 21,
    r: 20.5,
    fill: "#E6E9ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.94 26.465c0-.603.49-1.093 1.093-1.093H26.24c.604 0 1.093.49 1.093 1.093V41.5H13.94V26.465Z",
    fill: "#191C1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.333 31.386h7.654c.603 0 1.093.49 1.093 1.093v7.927c0 .604-.49 1.093-1.093 1.093h-7.654V31.386Z",
    fill: "#707780"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92 30.293c0-.604.49-1.094 1.093-1.094h7.927v12.3H6.013c-.603 0-1.093-.49-1.093-1.093V30.293Z",
    fill: "#464B52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.305 35.504h.748v.615H19.79v-.615h.748v-2.002l-.59.344-.29-.55 1.101-.645h.546v2.853ZM32.258 37.339c.204.06.36.162.468.31a.843.843 0 0 1 .167.531.86.86 0 0 1-.35.724c-.232.173-.547.26-.944.26a2.29 2.29 0 0 1-.689-.103 1.461 1.461 0 0 1-.536-.285l.241-.546c.315.223.631.334.95.334.21 0 .362-.036.457-.108.095-.076.143-.192.143-.35 0-.154-.048-.265-.143-.334-.095-.069-.247-.103-.457-.103h-.497v-.596h.413c.2 0 .348-.034.443-.103.098-.069.147-.175.147-.32 0-.14-.042-.249-.128-.325-.085-.075-.208-.113-.369-.113-.144 0-.295.03-.452.089-.158.056-.31.138-.458.246l-.24-.546c.137-.118.314-.212.53-.28.22-.073.445-.109.674-.109.237 0 .443.04.62.118a.904.904 0 0 1 .409.325.839.839 0 0 1 .147.492c0 .187-.049.35-.147.492a.804.804 0 0 1-.399.3ZM10.778 37.417v.615H8.39v-.566l1.157-1.225c.242-.255.364-.492.364-.708 0-.276-.158-.413-.473-.413-.144 0-.295.03-.452.088a1.862 1.862 0 0 0-.463.246l-.24-.546a1.51 1.51 0 0 1 .53-.28c.217-.073.438-.109.665-.109.36 0 .648.087.86.261a.85.85 0 0 1 .325.699c0 .2-.042.385-.127.556-.083.17-.222.36-.419.57l-.772.812h1.432Z",
    fill: "#F7F9FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.283 13.074h-1.64v-.547h2.187v2.05c0 .401-.156.97-.542 1.43-.398.473-1.028.817-1.936.756l.036-.545c.732.049 1.195-.222 1.481-.563.297-.353.414-.795.414-1.078v-1.503ZM15.717 13.074h1.64v-.547H15.17v2.05c0 .401.156.97.542 1.43.398.473 1.028.817 1.936.756l-.036-.545c-.732.049-1.195-.222-1.481-.563a1.792 1.792 0 0 1-.414-1.078v-1.503Z",
    fill: "#FBD458"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.083 11.708h6.834v3.553a3.28 3.28 0 0 1-3.28 3.28h-.274a3.28 3.28 0 0 1-3.28-3.28v-3.553Z",
    fill: "#FBD458"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.031 18.26c.407.18.858.281 1.332.281h.274a3.28 3.28 0 0 0 3.28-3.28v-3.553h-1.094v3.28a3.28 3.28 0 0 1-3.28 3.28h-.273c-.08 0-.16-.003-.239-.009Z",
    fill: "#EFBA0F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.537 11.434c0-.15.122-.273.273-.273h7.38a.273.273 0 0 1 0 .547h-7.38a.273.273 0 0 1-.273-.274Z",
    fill: "#FBD458"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.543 18.54c0-.15.123-.272.274-.272h1.64a.273.273 0 0 1 0 .546h-1.64a.273.273 0 0 1-.274-.273Z",
    fill: "#EFBA0F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.817 21.001h1.64v-2.187h-1.64v2.187Z",
    fill: "#FBD458"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.27 21.001h2.733v.547H19.27V21Z",
    fill: "#EFBA0F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.45 22.095h4.373a.547.547 0 0 0-.546-.547h-3.28a.547.547 0 0 0-.547.547Z",
    fill: "#FBD458"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.63 24.281h6.013v-1.64a.547.547 0 0 0-.546-.546h-4.92a.547.547 0 0 0-.547.546v1.64ZM17.083 25.374h7.107v-.547a.547.547 0 0 0-.547-.546H17.63a.547.547 0 0 0-.547.546v.547Z",
    fill: "#32363B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.083 24.828h7.107a.547.547 0 0 0-.547-.546H17.63a.547.547 0 0 0-.547.546ZM17.63 22.686c0-.326.245-.591.547-.591h4.646v.591c0 .653-.49 1.183-1.093 1.183h-4.1v-1.183Z",
    fill: "#464B52"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.083 11.708h6.834v.41h-6.834v-.41Z",
    fill: "#6C5200"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.817 20.18c0 .137-.137.547-.547.82h.547V20.182Z",
    fill: "#FBD458"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.79 20.327a1.295 1.295 0 0 1-.52.674h.547v-.82a.53.53 0 0 1-.028.146Zm0 .082a1.36 1.36 0 0 1-.434.565h.433v-.565Z",
    fill: "#FBD458"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.457 20.18c0 .137.136.547.546.82h-.546V20.182Z",
    fill: "#FBD458"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.484 20.327a1.295 1.295 0 0 0 .52.674h-.547v-.82c0 .034.008.084.027.146Zm0 .082a1.36 1.36 0 0 0 .434.565h-.434v-.565Z",
    fill: "#FBD458"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.27 22.915c0-.151.122-.273.273-.273h2.187c.151 0 .273.122.273.273v.547a.273.273 0 0 1-.273.273h-2.187a.273.273 0 0 1-.273-.273v-.547Z",
    fill: "#FBD458"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.61 23.188a.068.068 0 1 1-.136 0 .068.068 0 0 1 .137 0ZM21.798 23.188a.068.068 0 1 1-.136 0 .068.068 0 0 1 .136 0Z",
    fill: "#EFBA0F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.356 15.18c.166-.163.34-.342.459-.542a.394.394 0 0 0 .054-.205.24.24 0 0 0-.093-.202.402.402 0 0 0-.26-.076.981.981 0 0 0-.354.072 1.581 1.581 0 0 0-.362.206l-.163-.358a1.17 1.17 0 0 1 .412-.225 1.6 1.6 0 0 1 .505-.083c.159 0 .299.026.42.08.122.05.217.124.284.22.07.094.105.202.105.324a.617.617 0 0 1-.097.346 4.003 4.003 0 0 1-.451.556c-.11.113-.11.28-.11.392h-.481c0-.173-.003-.373.132-.505Zm-.132 1.3v-.525h.544v.525h-.544Z",
    fill: "#32363B"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyRanking);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/emptyRanking.svg";